module.exports = __webpack_public_path__ + "img/surfaceWater.773c4c21.svg";